import React from 'react';
import Button from '@mui/material/Button';
import { CircularProgress, Box } from '@mui/material';
import { useStyles } from './styles';

export function BookButton({
  sx,
  title = 'Submit',
  type = 'primary',
  variant = 'contained',
  onSubmit,
  isLoading = false,
  icon = null,
  fullWidth = false,
  size = 'medium',
}) {
  const classes = useStyles();

  return (
    <Button
      className={classes.primary}
      color={type}
      variant={variant}
      onClick={onSubmit}
      disabled={isLoading}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1, // Adds space between icon and text
        minWidth: 120,
        ...sx,
      }}
      fullWidth={fullWidth}
      size={size}
    >
      {isLoading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <>
          {icon && <Box component="span" display="flex">{icon}</Box>}
          {title}
        </>
      )}
    </Button>
  );
}
